import * as C from '@/consts'
import component from '@/libs/component'
import store from '@/store'

const Agree = () => import(/* webpackChunkName: "register" */ './Agree')
const Email = () => import(/* webpackChunkName: "register" */ './Email')
const Password = () => import(/* webpackChunkName: "register" */ './Password')
const Profile = () => import(/* webpackChunkName: "register" */ './Profile')
const License = () => import(/* webpackChunkName: "register" */ './License')
const Confirm = () => import(/* webpackChunkName: "register" */ './Confirm')
const Completed = () => import(/* webpackChunkName: "register" */ './Completed')

export default [
  {
    path: 'register',
    name: 'register',
    redirect: to => {
      // 同意事項があれば agree へ。なければ email へリダイレクトする
      return store.getters['org/hasAgreements'] ? { name: 'register/agree' } : { name: 'register/email' }
    }
  },
  {
    path: 'register/agree',
    name: 'register/agree',
    ...component(Agree),
    meta: {
      type: C.PAGE_REGISTER
    }
  },
  {
    path: 'register/email',
    name: 'register/email',
    ...component(Email),
    meta: {
      type: C.PAGE_REGISTER
    }
  },
  {
    path: 'register/password',
    name: 'register/password',
    ...component(Password),
    meta: {
      type: C.PAGE_REGISTER
    }
  },
  {
    path: 'register/profile',
    name: 'register/profile',
    ...component(Profile),
    meta: {
      type: C.PAGE_REGISTER
    }
  },
  {
    path: 'register/license',
    name: 'register/license',
    ...component(License),
    meta: {
      type: C.PAGE_REGISTER
    }
  },
  {
    path: 'register/confirm',
    name: 'register/confirm',
    ...component(Confirm),
    meta: {
      type: C.PAGE_REGISTER
    }
  },
  {
    path: 'register/completed',
    name: 'register/completed',
    ...component(Completed),
    meta: {
      type: C.PAGE_REGISTER
    }
  }
]
